import React from 'react'
import { DataGrid, GridCellValue, GridColDef, GridRowSelectedParams, GridToolbarContainer, GridToolbarExport } from '@material-ui/data-grid';
import { format } from 'date-fns'
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

interface GaugeTableProps {
    data?: any
    admin: boolean
    onRowSelected?: (param: GridRowSelectedParams) => any
    onCellDeleteClick: (docId: GridCellValue, docImageUrl: GridCellValue) => any
}

function ExportToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarExport />
        </GridToolbarContainer>
    );
}

export default function GaugeTable(props: GaugeTableProps) {

    const columns: GridColDef[] = [
        {
            field: 'DateTime',
            headerName: 'Created At',
            width: 160,
            disableClickEventBubbling: true,
            renderCell: (params) => {
                return format(new Date((params.getValue(params.id, "DateTime") as number)), "dd/MM/yy hh:mm a") //
            }
        },
        {
            field: "Name",
            headerName: "Name",
            width: 250,
            disableClickEventBubbling: true,
        },
        {
            field: 'Location',
            headerName: 'Location',
            width: 200,
            disableClickEventBubbling: true,
            valueGetter: (params) =>
                `${params.getValue(params.id, 'Latitude') || ''}, ${params.getValue(params.id, 'Longitude') || ''}`,
        },
        {
            field: 'Address',
            headerName: 'Address',
            width: 250,
            disableClickEventBubbling: true,
        },
        {
            field: 'WatershedCode',
            headerName: 'Watershed Code',
            width: 190,
            disableClickEventBubbling: true,
        },
        {
            field: 'Verified',
            headerName: 'Verified',
            width: 150,
        },
        {
            field: 'OwnerName',
            headerName: 'Owner',
            width: 200,
            disableClickEventBubbling: true,
            hide: !props.admin
        },
        {
            field: 'id',
            headerName: ' ',
            width: 50,
            flex: 1,
            disableClickEventBubbling: true,
            align: 'right',
            renderCell: (params) => {
                return <div>
                    {
                        params.getValue(params.id, 'Verified')  === 'false'  && <IconButton aria-label="delete" onClick={() => props.onCellDeleteClick(params.getValue(params.id, 'docId'), params.getValue(params.id, 'Image'))}>
                            <DeleteIcon />
                        </IconButton>
                    }
                </div>
            }
        }
    ];

    return (
        props.admin ?
            <DataGrid rows={props.data} columns={columns} pageSize={20} autoHeight={true} onRowSelected={props.onRowSelected} components={{ Toolbar: ExportToolbar }} />
            :
            <DataGrid rows={props.data} columns={columns} pageSize={20} autoHeight={true} onRowSelected={props.onRowSelected} />
    )
}